import { ASSET_STATUS_LABELS, ASSET_STATUS_COLORS } from "../../utils/constants";
import type { AssetStatus } from "../../types/product.types";

const toneStyles: Record<string, string> = {
  success: "bg-emerald-50 text-emerald-600",
  warning: "bg-amber-50 text-amber-600",
  critical: "bg-rose-50 text-rose-600",
  info: "bg-slate-100 text-slate-600",
};

interface AssetStatusBadgeProps {
  status: AssetStatus;
}

export function AssetStatusBadge({ status }: AssetStatusBadgeProps) {
  const tone = ASSET_STATUS_COLORS[status] || "info";
  const label = ASSET_STATUS_LABELS[status] || status;
  const classes = toneStyles[tone] || toneStyles.info;

  return (
    <span className={`rounded-full px-3 py-1 text-xs font-semibold ${classes}`}>
      {label}
    </span>
  );
}
